import PasswordExpired from "./PasswordExpired";
export default PasswordExpired;